module.exports = __webpack_public_path__ + "img/left.8989e863.svg";